import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES, SUBJECT_ROUTES } from '../../constants/routes';

import './navigation.css';

interface NavItem {
  route: string;
  label: string;
}

const NAV_ITEMS: NavItem[] = [
  {
    route: `${ROUTES.GRADE_10}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}`,
    label: 'Хлопці 10 клас',
  },
  {
    route: `${ROUTES.GRADE_10}/${SUBJECT_ROUTES.MEDICINE}`,
    label: 'Дівчата 10 клас',
  },
  {
    route: `${ROUTES.GRADE_11}/${SUBJECT_ROUTES.NATIONAL_DEFENSE}`,
    label: 'Хлопці 11 клас',
  },
  {
    route: `${ROUTES.GRADE_11}/${SUBJECT_ROUTES.MEDICINE}`,
    label: 'Дівчата 11 клас',
  },
  { route: ROUTES.CONTACTS, label: 'Наші контакти' },
];

export const Navigation: React.FC = () => {
  const location = useLocation();

  const activeKey =
    NAV_ITEMS.find((item) => location.pathname.startsWith(item.route))?.route ||
    ROUTES.HOME;

  return (
    <Nav variant="pills" activeKey={activeKey} role="navigation" aria-label="Головна навігація">
      {NAV_ITEMS.map((item) => (
        <Nav.Item key={item.route}>
          <Nav.Link 
            as={Link} 
            to={item.route} 
            eventKey={item.route}
            aria-current={activeKey === item.route ? 'page' : undefined}
          >
            {item.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};
